import HIKLossAttachmentModal from './HIK_loss_attachment-modal.vue'
export default HIKLossAttachmentModal
